module.exports = __webpack_public_path__ + "assets/img/bedroom_8-3.812c311e.jpg";